import React, { useMemo } from 'react';
import {
  TRIAL_RESTRICTION_TYPE,
  TRIAL_USER_LEVEL,
} from '../../consts/restrictionTypes';
import { useGlobalContext } from '../GlobalContextProvider/GlobalContextProvider';
import StaticImage from '../StaticImage';
import UniversalLink from '../UniversalLink/UniversalLink';
import {
  AlphabetLetter,
  AlphabetListFragment,
  AlphabetLink,
  Container,
  List,
  AlphabetLinkContainer,
} from './AlphabetList.slyled';

const compareByLetter = (a, b) => a.title.localeCompare(b.title);

const gatePageIcon = '/img/gated-page-icon.svg';

const AlphabetList = ({ items }) => {
  const { user } = useGlobalContext();

  const alphabetList = useMemo(() => {
    const list = {};
    const sortedItems = items
      .map((el) => ({ ...el, title: el.title.trim() }))
      .sort(compareByLetter);

    for (const item of sortedItems) {
      const firstLetter = item.title[0].toLowerCase();

      if (list[firstLetter]) {
        list[firstLetter].push(item);
      } else {
        list[firstLetter] = [item];
      }
    }

    return list;
  }, [items]);

  return (
    <Container>
      {Object.entries(alphabetList).map(([key, element]) => (
        <AlphabetListFragment key={key}>
          <AlphabetLetter>{key}</AlphabetLetter>
          <List>
            {element.map((el) => {
              const trialUserAvailability =
                user &&
                user.userLevel === TRIAL_USER_LEVEL &&
                el.restrictionType === TRIAL_RESTRICTION_TYPE;

              return (
                <AlphabetLinkContainer key={el.title}>
                  <UniversalLink key={el.title} href={el.path || el.url || ''}>
                    <AlphabetLink>{el.title}</AlphabetLink>
                  </UniversalLink>
                  {trialUserAvailability && (
                    <div>
                      <StaticImage
                        width={16}
                        height={16}
                        alt='gatePageIcon'
                        src={gatePageIcon}
                        priority
                      />
                    </div>
                  )}
                </AlphabetLinkContainer>
              );
            })}
          </List>
        </AlphabetListFragment>
      ))}
    </Container>
  );
};

AlphabetList.propTypes = {};

AlphabetList.defaultProps = {};

export default AlphabetList;
